/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_A7Inputs */

const en_formatter_faq_a7 = /** @type {(inputs: Formatter_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordinary keys keep their original order. Keys that consist only of digits are an exception: they are emitted in ascending numeric order and placed before all other keys, because that is how the underlying object model stores them.`)
};

const ko_formatter_faq_a7 = /** @type {(inputs: Formatter_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일반적인 키는 원래 순서를 유지합니다. 숫자로만 이루어진 키는 예외로, 오름차순으로 출력되며 다른 모든 키보다 앞에 놓입니다. 그 아래 객체 모델이 그렇게 저장하기 때문입니다.`)
};

const ja_formatter_faq_a7 = /** @type {(inputs: Formatter_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常のキーは元の順序を保ちます。数字だけで構成されたキーは例外で、昇順で出力され、ほかのすべてのキーより前に置かれます。その下のオブジェクトモデルがそう保存するためです。`)
};

/**
* | output |
* | --- |
* | "Ordinary keys keep their original order. Keys that consist only of digits are an exception: they are emitted in ascending numeric order and placed before all..." |
*
* @param {Formatter_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_a7 = /** @type {((inputs?: Formatter_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_a7(inputs)
	if (locale === "ko") return ko_formatter_faq_a7(inputs)
	return ja_formatter_faq_a7(inputs)
});